import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ifd-link-area compare-mode mt8 ta-right" }

import { openNewInfraDoctorTab } from 'src/lib/moviePlayerHelper';
import type { GIMovie, GIMovieGeoIndex, GIMovieList } from 'src/models/geoItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfraDoctorLinkArea',
  props: {
    ifdLinkPrefix: {},
    currentMovie: {},
    currentMovieList: {},
    currentMgi: {},
    currentMovieIdx: {},
    currentMgiIdx: {},
    isFirstMovie: { type: Boolean },
    isLastMovie: { type: Boolean },
    isReady: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const openInfraDoctor = (): void => {
  if (!props.isReady ||
    !props.ifdLinkPrefix ||
    !props.currentMovie ||
    !props.currentMovieList ||
    !props.currentMgi) return;

  openNewInfraDoctorTab({
    ifdLinkPrefix: props.ifdLinkPrefix,
    currentMovieList: props.currentMovieList,
    currentMovie: props.currentMovie,
    currentMovieIdx: props.currentMovieIdx,
    currentMgi: props.currentMgi,
    currentMgiIdx: props.currentMgiIdx,
    isFirstMovie: props.isFirstMovie,
    isLastMovie: props.isLastMovie,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-sm btn-info",
      onClick: openInfraDoctor
    }, " インフラドクターを開く ")
  ]))
}
}

})